module.exports = __webpack_public_path__ + "static/dip-65d509dc1a4e13677b8a5f97e01091df.png";